<template>
  <div class="user-modal-wrapper">
    <div class="user-modal">
      <p v-if="loading">Зареждане...<br />&nbsp;</p>
      <form v-else>
        <p>Настройки на мейлите с нотификации</p>
        <div class="row">
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="notification.budgetParts.active"
              />
              <span class="slider"></span>
            </label>
          </div>
          <p>Получаване на дневни отчети по бюджетите за частите</p>
        </div>
        <div class="row">
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="notification.budgetReached.active"
              />
              <span class="slider"></span>
            </label>
          </div>
          <p>Достигане на {{ notification.budgetReached.percent }}% от планирания бюджет</p>
          <div class="percent-input">
            <input
              type="number"
              v-model="notification.budgetReached.percent"
              :disabled="!notification.budgetReached.active"
              @keydown.enter.prevent
            />
          </div>
        </div>
        <div class="row">
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="notification.budgetDifference.active"
              />
              <span class="slider"></span>
            </label>
          </div>
          <p>Разлика от {{ notification.budgetDifference.percent }}% между разходи и приходи</p>
          <div class="percent-input">
            <input
              type="number"
              v-model="notification.budgetDifference.percent"
              :disabled="!notification.budgetDifference.active"
              @keydown.enter.prevent="save()"
            />
          </div>
        </div>
        <div class="user-modal-actions">
          <div class="btns">
            <button class="btn btn-close" @click.prevent="close()">
              <span class="mck">F</span>
              Отказ
            </button>
            <button
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save"
            >
              <span class="mck">Y</span>
              Запис
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['getUser']),
  },
  data() {
    return {
      loading: true,
      notification: {
        budgetParts: {
          active: false,
        },
        budgetReached: {
          active: false,
          percent: null,
        },
        budgetDifference: {
          active: false,
          percent: null,
        },
      },
    };
  },
  methods: {
    getNotification() {
      this.loading = true;
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/notifications/${this.getUser._id}`)
        .then((res) => {
          if (res.data) {
            if (res.data._id) {
              this.notification = res.data;
            }
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
    isValid() {
      if (
        (this.notification.budgetReached.active &&
          this.notification.budgetReached.percent <= 0) ||
        this.notification.budgetReached.percent > 100
      ) {
        this.$snotify.error('Невалиден/липсващ процент');
        return false;
      }
      if (
        (this.notification.budgetDifference.active &&
          this.notification.budgetDifference.percent <= 0) ||
        this.notification.budgetDifference.percent > 100
      ) {
        this.$snotify.error('Невалиден/липсващ процент');
        return false;
      }
      return true;
    },
    save() {
      if (this.isValid()) {
        this.$http
          .post(
            `${process.env.VUE_APP_BASE_URI}/notifications`,
            this.notification
          )
          .then(() => {
            this.$snotify.success('Вашите нотификации са успешно обновени');
            this.close();
          })
          .catch((err) => {
            this.$snotify.error('Нещо се обърка');
            console.log(err.response);
          });
      }
    },
    handleEvents(e) {
      if (e.code === 'Enter') {
        this.save();
      } else if (e.code === 'Escape') {
        this.close();
      }
    },
  },
  mounted() {
    this.$set(this.notification, 'user', this.getUser._id);
    this.getNotification();
    // this.notification.user = this.getUser._id
    // if (this.idToEdit) {
    //   this.getSpecificUser(this.idToEdit);
    // }
    // if (this.idToEdit === this.$store.state.user._id) {
    //   if (this.limitedFunctionality) {
    //     this.$snotify.warning(
    //       'Внимание! При редакция на профила ви ще бъдете разлогнати от системата и ще трябва да влезете отново.'
    //     );
    //   } else {
    //     this.$snotify.warning(
    //       'Внимание! Ако промените някое от собствените ви разрешения или статус ще бъдете разлогнати от системата.'
    //     );
    //   }
    // }
    window.addEventListener('keydown', this.handleEvents);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEvents);
  },
};
</script>

<style scoped>
.user-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}
.user-modal {
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 20px 30px 0;
  width: 550px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.user-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.user-modal form > p {
  font-weight: 500;
  margin-bottom: 2rem;
}
.row {
  align-items: center;
  display: flex;
  margin: 5px 0;
  min-height: 35px;
}
.percent-input {
  position: relative;
}
.percent-input::after {
  color: var(--color-main);
  content: '%';
  font-weight: 700;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.percent-input input {
  background-color: #f4f4f4;
  border: 1px solid #cecece;
  border-radius: 4px;
  height: 35px;
  padding-right: 30px;
  text-align: center;
  width: 75px;
}
.percent-input input::-webkit-outer-spin-button,
.percent-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.percent-input input[type='number'] {
  -moz-appearance: textfield;
}
.row > p {
  width: 100%;
}

/* .switch {
  margin: 0; 
} */
.slider {
  background-color: #b1b1b1;
}
.slider::before {
  bottom: 2px;
  height: 16px;
  left: 3px;
  width: 16px;
}
input:checked + .slider {
  background-color: var(--color-main);
}
input:checked + .slider:before {
  transform: translateX(22px);
}
/* .invalid .mck {
  color: #d91313;
} */
</style>
